import { render, staticRenderFns } from "./ProfileFriendItems.vue?vue&type=template&id=220f6f81&scoped=true&"
import script from "./ProfileFriendItems.vue?vue&type=script&lang=js&"
export * from "./ProfileFriendItems.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFriendItems.vue?vue&type=style&index=0&id=220f6f81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220f6f81",
  null
  
)

export default component.exports